export default {
  OPERACION_OPCION: (state, mutation) => {
    state.operacion = mutation.oper
    state.id = mutation.id
  },
}
